import React from "react";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";
import Uretim from "../Components/uretim/Uretim";
import useSEO from "../seo/useSEO";

function UretimPage() {
  useSEO({
    title: "CNC Talaşlı İmalat ve Üretim | Aypin Otomat",
    description:
      "Aypin Otomat CNC talaşlı imalat kapsamında özel civata, pim, pirinç parça ve burç üretim çözümleri sunar. Üretim süreçlerimizi inceleyin.",
    path: "/uretim",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "Üretim",
        path: "/uretim",
      },
    ],
  });

  return (
    <>
      <TopBar />
      <Spacer2 />
      <Uretim />
    </>
  );
}

export default UretimPage;